export default __webpack_public_path__ + "static/bentoSectionBg3-a5494e08ed4dc64d6db625f918c876f4.webp";